import React from "react";

import useTheme from "../../hooks/useTheme";
import { ERPType } from "../../types/types";

export default function Radix() {
  const theme = useTheme();

  return (
    <div>
      <img
        src={theme.images.radix}
        style={{ height: 50, width: 100 }}
        alt={ERPType.radix}
      />
    </div>
  );
}
